import { render, staticRenderFns } from "./RedemptionRegister.vue?vue&type=template&id=55820add&scoped=true"
import script from "./RedemptionRegister.vue?vue&type=script&lang=js"
export * from "./RedemptionRegister.vue?vue&type=script&lang=js"
import style0 from "./RedemptionRegister.vue?vue&type=style&index=0&id=55820add&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55820add",
  null
  
)

export default component.exports